<div class="confirmation">
  <div class="confirmation__content">
    <h4>{{ caption }}</h4>
    <p>{{ message }}</p>
    <div class="confirmation__footer flex justify-end">
      <app-button
        customClass="outline"
        *ngIf="primaryButtonText"
        [label]="primaryButtonText"
        (action)="emitPrimaryButtonClick()"
        [isDisabled]="primaryButtonLoading"
      ></app-button>
      <app-button
        *ngIf="secondaryButtonText"
        [label]="secondaryButtonText"
        (action)="emitSecondaryButtonClick()"
        [isDisabled]="secondaryButtonLoading"
      ></app-button>
    </div>
  </div>
</div>
